// frontend/src/components/SEO/PageSEO.jsx
import { useEffect, useRef } from 'react';
import { Helmet } from 'react-helmet-async';
import config from '../../config';
import { useSEO } from '../../context/SEOContext';

// تصویر پیش‌فرض برای واتساپ و شبکه‌های اجتماعی
const DEFAULT_OG_IMAGE = config.getMediaUrl('/media/cms/logo/logo2.png');

export const PageSEO = ({ title, description, keywords, image, type = 'website', noindex = false }) => {
  const { setCustomSEO, clearCustomSEO } = useSEO();
  const hasSetSEO = useRef(false);
  const hasClearedSEO = useRef(false);

  useEffect(() => {
    if (!hasSetSEO.current) {
      hasSetSEO.current = true;
      setCustomSEO({ title, description, noindex });
    }
    
    return () => {
      if (!hasClearedSEO.current) {
        hasClearedSEO.current = true;
        clearCustomSEO();
      }
    };
  }, []);

  const currentUrl = window.location.href;
  const siteName = 'سان ایران';
  const ogImage = image ? config.getMediaUrl(image) : DEFAULT_OG_IMAGE;
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      
      {/* ========== Open Graph - برای واتساپ، تلگرام، فیسبوک ========== */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      
      {/* ========== Twitter Card ========== */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {/* ========== Robots ========== */}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      
      {/* ========== Canonical ========== */}
      <link rel="canonical" href={currentUrl} />
      
      {/* JSON-LD برای محصولات
      {type === 'product' && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "Product",
            "name": title,
            "description": description,
            "image": ogImage,
          })}
        </script>
      )} */}
      
      {/* JSON-LD برای مقالات */}
      {type === 'article' && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": title,
            "description": description,
            "image": ogImage,
          })}
        </script>
      )}
    </Helmet>
  );
};
